






















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class NoAccountMessage extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({default: true})
  isCardMode: boolean;

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }
}
